<template>
    <div>
        <div class="landing-page-panels">
            <form class="landing-page-panel _new" method="POST" action="/downloads">
              <input type="hidden" name="_token" :value="csrf">
              <input type="hidden" value="[20]" name="selected_content_upload_types">
              <button type="submit">
                <div class="box">
                  <div class="image">
                    <img src="/images/marketing-landing-page-thumbnail-system-branding.png">
                  </div>
                  <div class="content">
                    <div class="title">
                      System Branding
                    </div>
                    <div class="description">
                      Need logo's of our systems to use in your marketing and promotional activity? Download logo's and brand guidelines in seconds here!
                    </div>
                  </div>
                  <div class="footer">
                    <div class="logo"><img src="/images/powered-by-logo-epwin.png"></div>
                    <div class="powered-by">
                      <div>Powered By</div>
                      <div>Epwin Window Systems</div>
                    </div>
                    <div class="button">
                      <div class="btn">
                        <i class="fa fa-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            </form>
            <a class="landing-page-panel _new" href="/marketing/bagworld">
                <div class="box">
                    <div class="image">
                        <img src="/images/marketing-landing-page-thumbnail-bagworld.png">
                    </div>
                    <div class="content">
                        <div class="title">
                            Window / Corner Sample Bags
                        </div>
                        <div class="description">
                            We can manufacture any size of Transit Carry bag in a wide range of Materials & colours. Have your company logo either Screen printed , Embroidered or Heat Transferred onto your Bags.
                        </div>
                    </div>
                    <div class="footer">
                        <div class="logo"><img src="/images/powered-by-logo-bagworld.png"></div>
                        <div class="powered-by">
                            <div>Powered By</div>
                            <div>Bagworld</div>
                        </div>
                        <div class="button">
                            <div class="btn">
                                <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
            <a class="landing-page-panel _new" href="/marketing/keystone">
                <div class="box">
                    <div class="image">
                        <img src="/images/marketing-landing-page-thumbnail-keystone.png">
                    </div>
                    <div class="content">
                        <div class="title">
                            Home Improvement Market Research
                        </div>
                        <div class="description">
                          The new quarterly Consumer Fenestration trends Report exploring a wide-ranging selection of topics
                        </div>
                    </div>
                    <div class="footer">
                        <div class="logo"><img src="/images/powered-by-logo-keystone.png"></div>
                        <div class="powered-by">
                            <div>Powered By</div>
                            <div>Keystone Market Research</div>
                        </div>
                        <div class="button">
                            <div class="btn">
                                <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
            <form class="landing-page-panel" method="POST" action="/downloads">
                <input type="hidden" name="_token" :value="csrf">
                <input type="hidden" value="[1]" name="selected_content_upload_types">
                <button type="submit">
                    <div class="box">
                        <div class="image">
                            <img src="/images/marketing-landing-page-thumbnail-image-gallery.png">
                        </div>
                        <div class="content">
                            <div class="title">
                                Image Gallery
                            </div>
                            <div class="description">
                                Get access to our comprehensive image library where you can download a wealth of images for your online and offline marketing activity.
                            </div>
                        </div>
                        <div class="footer">
                            <div class="logo"><img src="/images/powered-by-logo-epwin.png"></div>
                            <div class="powered-by">
                                <div>Powered By</div>
                                <div>Epwin Window Systems</div>
                            </div>
                            <div class="button">
                                <div class="btn">
                                    <i class="fa fa-arrow-right"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </button>
            </form>
            <form class="landing-page-panel" method="POST" action="/downloads">
              <input type="hidden" name="_token" :value="csrf">
              <input type="hidden" value="[14]" name="selected_content_upload_types">
              <button type="submit">
                <div class="box">
                  <div class="image">
                    <img src="/images/marketing-landing-page-thumbnail-video-gallery.png">
                  </div>
                  <div class="content">
                    <div class="title">
                      Video Gallery
                    </div>
                    <div class="description">
                      Access our video library for a range of video assets to enhance your online activity.
                    </div>
                  </div>
                  <div class="footer">
                    <div class="logo"><img src="/images/powered-by-logo-epwin.png"></div>
                    <div class="powered-by">
                      <div>Powered By</div>
                      <div>Epwin Window Systems</div>
                    </div>
                    <div class="button">
                      <div class="btn">
                        <i class="fa fa-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            </form>
            <form class="landing-page-panel" method="POST" action="/downloads">
              <input type="hidden" name="_token" :value="csrf">
              <input type="hidden" value="[19]" name="selected_content_upload_types">
              <button type="submit">
                <div class="box">
                  <div class="image">
                    <img src="/images/marketing-landing-page-thumbnail-presentations.png">
                  </div>
                  <div class="content">
                    <div class="title">
                      Presentations
                    </div>
                    <div class="description">
                      Utilise our engaging presentations to ensure your customers are fully aware of the extensive features and benefits of our products and services.
                    </div>
                  </div>
                  <div class="footer">
                    <div class="logo"><img src="/images/powered-by-logo-epwin.png"></div>
                    <div class="powered-by">
                      <div>Powered By</div>
                      <div>Epwin Window Systems</div>
                    </div>
                    <div class="button">
                      <div class="btn">
                        <i class="fa fa-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            </form>
            <form class="landing-page-panel" method="POST" action="/downloads">
                <input type="hidden" name="_token" :value="csrf">
                <input type="hidden" value="[2]" name="selected_content_upload_types">
                <button type="submit">
                    <div class="box">
                        <div class="image">
                            <img src="/images/marketing-landing-page-thumbnail-brochures.png">
                        </div>
                        <div class="content">
                            <div class="title">
                                Brochure Downloads
                            </div>
                            <div class="description">
                                Access digital versions of brochures across trade, retail and commercial markets. Perfect for emailing
                                to customers or using as downloads on your own website.
                            </div>
                        </div>
                        <div class="footer">
                            <div class="logo"><img src="/images/powered-by-logo-epwin.png"></div>
                            <div class="powered-by">
                                <div>Powered By</div>
                                <div>Epwin Window Systems</div>
                            </div>
                            <div class="button">
                                <div class="btn">
                                    <i class="fa fa-arrow-right"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </button>
            </form>
            <a class="landing-page-panel" href="/marketing/marketing-portal">
                <div class="box">
                    <div class="image">
                        <img src="/images/marketing-landing-page-thumbnail-marketing-portal.png">
                    </div>
                    <div class="content">
                        <div class="title">
                            Marketing Portal
                        </div>
                        <div class="description">
                            Login to our Brandhub360 portal to order a wide range of professionally designed brochures, point of sale materials, advertising collateral and so much more.
                        </div>
                    </div>
                    <div class="footer">
                        <div class="logo"><img src="/images/powered-by-logo-brandhub360.png"></div>
                        <div class="powered-by">
                            <div>Powered By</div>
                            <div>Brandhub 360</div>
                        </div>
                        <div class="button">
                            <div class="btn">
                                <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
            <a class="landing-page-panel" href="/marketing/branded-workwear">
                <div class="box">
                    <div class="image">
                        <img src="/images/marketing-landing-page-thumbnail-branded-workwear.png">
                    </div>
                    <div class="content">
                        <div class="title">
                            Branded Workwear &amp; Merchandise
                        </div>
                        <div class="description">
                            Discounted Workwear with YOUR logo, with no minimum order quantities and at extremely competitive
                            prices. Not only this but you can now add your logo to merchandise.
                        </div>
                    </div>
                    <div class="footer">
                        <div class="logo"><img src="/images/powered-by-logo-brandhub360.png"></div>
                        <div class="powered-by">
                            <div>Powered By</div>
                            <div>Brandhub 360</div>
                        </div>
                        <div class="button">
                            <div class="btn">
                                <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
            <a class="landing-page-panel" href="/marketing/photography">
              <div class="box">
                <div class="image">
                  <img src="/images/marketing-landing-page-thumbnail-photography.png">
                </div>
                <div class="content">
                  <div class="title">
                    Photography
                  </div>
                  <div class="description">
                    Do you have a stunning installation that you would love to get some FREE professional photography of?
                  </div>
                </div>
                <div class="footer">
                  <div class="logo"><img src="/images/powered-by-logo-epwin.png"></div>
                  <div class="powered-by">
                    <div>Powered By</div>
                    <div>Epwin Window Systems</div>
                  </div>
                  <div class="button">
                    <div class="btn">
                      <i class="fa fa-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <form class="landing-page-panel" method="POST" action="/downloads">
              <input type="hidden" name="_token" :value="csrf">
              <input type="hidden" value="[16]" name="selected_content_upload_types">
              <button type="submit">
                <div class="box">
                  <div class="image">
                    <img src="/images/marketing-landing-page-thumbnail-how-to-guides.png">
                  </div>
                  <div class="content">
                    <div class="title">
                      "How to" Guides
                    </div>
                    <div class="description">
                      Get access to our comprehensive range of "How to" guides for you to download.
                    </div>
                  </div>
                  <div class="footer">
                    <div class="logo"><img src="/images/powered-by-logo-epwin.png"></div>
                    <div class="powered-by">
                      <div>Powered By</div>
                      <div>Epwin Window Systems</div>
                    </div>
                    <div class="button">
                      <div class="btn">
                        <i class="fa fa-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            </form>
            <a class="landing-page-panel" href="/marketing/bespoke-marketing">
                <div class="box">
                    <div class="image">
                        <img src="/images/marketing-landing-page-thumbnail-bespoke-marketing.png">
                    </div>
                    <div class="content">
                        <div class="title">
                            Bespoke Marketing
                        </div>
                        <div class="description">
                            Work with the Epwin Window Systems Design team to get bespoke support from award-winning marketing experts to take your business to the next level.
                        </div>
                    </div>
                    <div class="footer">
                        <div class="logo"><img src="/images/powered-by-logo-epwin.png"></div>
                        <div class="powered-by">
                            <div>Powered By</div>
                            <div>Epwin Window Systems</div>
                        </div>
                        <div class="button">
                            <div class="btn">
                                <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
            <a class="landing-page-panel" href="/marketing/team4-marketing">
                <div class="box">
                    <div class="image">
                        <img src="/images/marketing-landing-page-thumbnail-pr.png">
                    </div>
                    <div class="content">
                        <div class="title">
                            PR
                        </div>
                        <div class="description">
                            Got a project you want to promote in the press – or need some copy that communicates the value of what your business has to offer? Our
                            PR partner Team 4 Marketing is here to help.
                        </div>
                    </div>
                    <div class="footer">
                        <div class="logo"><img src="/images/powered-by-logo-team-4-marketing.png"></div>
                        <div class="powered-by">
                            <div>Powered By</div>
                            <div>Team 4 Marketing</div>
                        </div>
                        <div class="button">
                            <div class="btn">
                                <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
            <a class="landing-page-panel" href="/marketing/social-media">
                <div class="box">
                    <div class="image">
                        <img src="/images/marketing-landing-page-thumbnail-social-media.png">
                    </div>
                    <div class="content">
                        <div class="title">
                            Social Media
                        </div>
                        <div class="description">
                            Want to make more of social media in your marketing activity? Get ideas and best practice guidelines
                            from the Epwin Window Systems award-winning marketing team.
                        </div>
                    </div>
                    <div class="footer">
                        <div class="logo"><img src="/images/powered-by-logo-epwin.png"></div>
                        <div class="powered-by">
                            <div>Powered By</div>
                            <div>Epwin Window Systems</div>
                        </div>
                        <div class="button">
                            <div class="btn">
                                <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
            <a class="landing-page-panel" href="/offers-and-promotions/email-marketing">
              <div class="box">
                <div class="image">
                  <img src="/images/offers-and-promotions-landing-page-thumbnail-email-marketing.png">
                </div>
                <div class="content">
                  <div class="title">
                    Email Marketing
                  </div>
                  <div class="description">
                    Email marketing has become the most powerful way of generating new business, maintaining existing customer relations and building awareness. Receive 5% discount on 3 month campaigns, 10% for 6 month, 20% for 12 months through Connect.
                  </div>
                </div>
                <div class="footer">
                  <div class="logo"><img src="/images/powered-by-logo-insightdata.png"></div>
                  <div class="powered-by">
                    <div>Powered By</div>
                    <div>Insight Data</div>
                  </div>
                  <div class="button">
                    <div class="btn">
                      <i class="fa fa-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a class="landing-page-panel" href="/offers-and-promotions/telesales-lead-generation">
              <div class="box">
                <div class="image">
                  <img src="/images/offers-and-promotions-landing-page-thumbnail-telesales-lead-generation.png">
                </div>
                <div class="content">
                  <div class="title">
                    Telesales - lead generation
                  </div>
                  <div class="description">
                    Insight Data has a state-of-the-art call centre and experienced telemarketing team operating to the highest standards. Get an exclusive 10% discount on telesales over £500.
                  </div>
                </div>
                <div class="footer">
                  <div class="logo"><img src="/images/powered-by-logo-insightdata.png"></div>
                  <div class="powered-by">
                    <div>Powered By</div>
                    <div>Insight Data</div>
                  </div>
                  <div class="button">
                    <div class="btn">
                      <i class="fa fa-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a class="landing-page-panel" href="/offers-and-promotions/sales-tracker-industry-crm">
              <div class="box">
                <div class="image">
                  <img src="/images/offers-and-promotions-landing-page-thumbnail-sales-tracker-industry-crm.png">
                </div>
                <div class="content">
                  <div class="title">
                    Salestracker – Industry CRM
                  </div>
                  <div class="description">
                    Salestracker is an industry CRM with real-time prospect data. Get 15% discount for annual payment, or 12 months for the price of 10 for monthly payment options.
                  </div>
                </div>
                <div class="footer">
                  <div class="logo"><img src="/images/powered-by-logo-insightdata.png"></div>
                  <div class="powered-by">
                    <div>Powered By</div>
                    <div>Insight Data</div>
                  </div>
                  <div class="button">
                    <div class="btn">
                      <i class="fa fa-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a class="landing-page-panel" href="/offers-and-promotions/market-research">
              <div class="box">
                <div class="image">
                  <img src="/images/offers-and-promotions-landing-page-thumbnail-market-research.png">
                </div>
                <div class="content">
                  <div class="title">
                    Market research
                  </div>
                  <div class="description">
                    Get an exclusive 10% discount on campaigns over £500 to help make informed business decisions, reducing risk and costly mistakes.
                  </div>
                </div>
                <div class="footer">
                  <div class="logo"><img src="/images/powered-by-logo-insightdata.png"></div>
                  <div class="powered-by">
                    <div>Powered By</div>
                    <div>Insight Data</div>
                  </div>
                  <div class="button">
                    <div class="btn">
                      <i class="fa fa-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a class="landing-page-panel" href="/web-support/touch-for-fabricators" v-if="logged_in_user.isStaff || logged_in_user.isFabricator">
                <div class="box">
                    <div class="image">
                        <img src="/images/web-support-landing-page-thumbnail-quote-software-for-fabricators.png">
                    </div>
                    <div class="content">
                        <div class="title">
                            Quote &amp; Ordering Software
                        </div>
                        <div class="description">
                            TOUCH manages everything from the consumer enquiry and quoting to production and supply with everything else in between.
                        </div>
                    </div>
                    <div class="footer">
                        <div class="logo"><img src="/images/powered-by-logo-touch.png"></div>
                        <div class="powered-by">
                            <div>Powered By</div>
                            <div>TOUCH</div>
                        </div>
                        <div class="button">
                            <div class="btn">
                                <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
            <a class="landing-page-panel" href="/web-support/websites" v-if="logged_in_user.isStaff || logged_in_user.isInstaller || logged_in_user.isTradeCounter || logged_in_user.isOther || logged_in_user.isBuilder">
                <div class="box">
                    <div class="image">
                        <img src="/images/web-support-landing-page-thumbnail-websites-for-installers.png">
                    </div>
                    <div class="content">
                        <div class="title">
                            Installer website service
                        </div>
                        <div class="description">
                            Affordable website themes designed specifically for Epwin installers.
                        </div>
                    </div>
                    <div class="footer">
                        <div class="logo"><img src="/images/powered-by-logo-the-consultancy.png"></div>
                        <div class="powered-by">
                            <div>Powered By</div>
                            <div>The Consultancy</div>
                        </div>
                        <div class="button">
                            <div class="btn">
                                <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
            <a class="landing-page-panel" href="/web-support/bespoke-websites" v-if="logged_in_user.isStaff || logged_in_user.isFabricator">
                <div class="box">
                    <div class="image">
                        <img src="/images/web-support-landing-page-thumbnail-websites.png">
                    </div>
                    <div class="content">
                        <div class="title">
                            Fabricator Website Service
                        </div>
                        <div class="description">
                            With over 30 years in the industry we can offer a stunning website that delivers real results.
                        </div>
                    </div>
                    <div class="footer">
                        <div class="logo"><img src="/images/powered-by-logo-the-consultancy.png"></div>
                        <div class="powered-by">
                            <div>Powered By</div>
                            <div>The Consultancy</div>
                        </div>
                        <div class="button">
                            <div class="btn">
                                <i class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
};
</script>
